
import { Component, Vue } from "vue-property-decorator";
import Sidebar from "@/components/navigations/Sidebar.vue";
import CardProchaineActivite from "@/components/card/CardProchaineActivite.vue";
import CardActivite from "@/components/card/CardActivite.vue";
import panelActivite from "@/components/panel/PanelActivite.vue";
import optionActivite from "@/components/option/OptionActivite.vue";
import Modal from "@/components/modal/Modal.vue";
import Cta from "@/components/buttons/Button.vue";
import Tag from "@/components/tags/Tag.vue";
import Alert from "@/components/alert/Alert.vue";
import { activites, data, login, timeline } from "@/store";
import {
  Activite,
  ActiviteRecensementState,
  ElementKey,
  ProchaineActivite,
  User,
} from "@/models";
import TimelineService from "@/services/timeline.service";
import { found, select, isSameDay } from "@/helpers";
import dayjs from "dayjs";

@Component({
  methods: {
    found,
    select,
    isSameDay,
  },
  components: {
    Sidebar,
    CardProchaineActivite,
    Cta,
    CardActivite,
    panelActivite,
    optionActivite,
    Modal,
    Tag,
    Alert,
  },
})
/** "Timeline v2" — legacy Timeline sign-up page: next activities carousel, filterable activity list, sign-up panels. */
export default class Timeline extends Vue {
  private dataReady = false;
  private panelActivite = false;
  private panelActiviteData: Activite | null = null;
  private optionActivite = false;
  private optionActiviteData: Activite | null = null;
  private filterModal = false;
  private nouveauteModal = false;
  private filterTypes: ElementKey[] | null = null;
  private filterList: ElementKey[] = [
    { id: "ALL", libelle: "Tous" },
    { id: "NON_REPONDU", libelle: "Seulement où je dois répondre" },
    { id: "ENGAGE", libelle: "Seulement où je suis engagé" },
  ];
  private filterListSelected = "ALL";

  private paramSliderProchaineActivite = {
    align: "center",
    circular: true,
  };

  async mounted(): Promise<void> {
    // Check info nouveautés
    // if (LocalStorageApp.getItem("pcp-timeline-v") !== "2.1.2") {
    //   this.nouveauteModal = true;
    //   LocalStorageApp.setItem("pcp-timeline-v", "2.1.2");
    // }

    await data.typesActivites();
    if (this.typesActivite) {
      this.filterTypes = [...this.typesActivite.filter((t) => t.id !== "9")];
    }

    await this.dataTimeline();
    this.dataReady = true;
  }

  /** Reloads next activities + the filtered activity list, using the current type/status filters. */
  private async dataTimeline() {
    await timeline.prochaineActivite();
    await timeline.activites({
      types: this.filterTypes ?? [],
      list: this.filterListSelected,
    });
  }

  private openEope(): void {
    window.open(
      "https://eope.protectioncivile.org",
      "_blank",
      "noopener,noreferrer"
    );
  }

  private confirmNouveaute(): void {
    this.nouveauteModal = false;
  }

  /** Records a sign-up state change for an activity, then refreshes the list. */
  private async setRecensementState(
    activite: string,
    state: ActiviteRecensementState
  ): Promise<void> {
    await TimelineService.recensement(activite, state);
    await this.dataTimeline();
  }

  /** Opens the activity detail side panel (used by the timeline list's `sidebarActivite` event). */
  private async openSidebar(id: string): Promise<void> {
    this.panelActivite = true;
    if (await activites.activite(id)) {
      this.panelActiviteData = activites.getActivite;
    }
  }

  /** Opens the activity quick-action panel (used by the "next activities" carousel). */
  private async openOptionActivite(id: string): Promise<void> {
    this.optionActivite = true;
    if (await activites.activite(id)) {
      this.optionActiviteData = activites.getActivite;
    }
  }

  private closePanel(): void {
    this.panelActivite = false;
    this.panelActiviteData = null;
  }

  private closeOption(): void {
    this.optionActivite = false;
    this.optionActiviteData = null;
  }

  private openFilter(): void {
    this.filterModal = true;
  }

  /** Closes the filter modal and reloads the list with the newly-selected filters. */
  private async confirmFilter(): Promise<void> {
    this.filterModal = false;
    await this.dataTimeline();
  }

  /** Toggles an activity type in/out of the active type filter set. */
  private async switchFilterType(selected: ElementKey): Promise<void> {
    if (this.filterTypes) {
      this.filterTypes = select(this.filterTypes, selected);
    }
  }

  /** Sets the sign-up status filter ("ALL" / "NON_REPONDU" / "ENGAGE"). */
  private selectType(selected: string): void {
    this.filterListSelected = selected;
  }

  private date(date: string, format = "DD/MM/YYYY"): string {
    return dayjs(date).format(format);
  }

  get prochaineActivite(): ProchaineActivite[] | null {
    return timeline.getProchaineActivite;
  }

  get activites(): Activite[] | null {
    return timeline.getActivites?.filter((a) => a.type?.id !== "9") ?? null;
  }

  get typesActivite(): ElementKey[] | null {
    return data.getTypesActivite
      ? data.getTypesActivite.filter((t) => t.id !== "9")
      : null;
  }

  get context(): User | null {
    return login.getContext;
  }
}
